import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IRowNode } from 'ag-grid-community';

import { TooltipComponent } from '@shared/tooltip/tooltip.component';
import { DetectEllipsisDirective } from '@directives/detect-ellipsis.directive';

interface CustomParams {
    dataQa: string;
    tooltipGetter?: (node: ICellRendererParams) => string;
}

@Component({
    imports: [TooltipComponent, DetectEllipsisDirective],
    template: `
        <div
            tabindex="0"
            class="clickable"
            wfeDetectEllipsis
            (ellipsedChange)="onEllipsedChange($event)"
            [attr.data-qa]="params.dataQa">
            @if (tooltip && isNameEllipsed) {
                <app-tooltip>
                    <span
                        trigger
                        class="overflow-hidden text-nowrap"
                        style="text-overflow: ellipsis">
                        {{ params.valueFormatted ?? params.value }}
                    </span>
                    <div content class="grid gap-5 text-s">
                        {{ tooltip }}
                    </div>
                </app-tooltip>
            } @else {
                {{ params.valueFormatted ?? params.value }}
            }
        </div>
    `,
})
export class DocumentNameCellComponent implements ICellRendererAngularComp {
    public params!: ICellRendererParams & CustomParams;
    public tooltip: string | undefined;
    isNameEllipsed = false;
    lockUntil = 0;

    agInit(params: ICellRendererParams & CustomParams): void {
        this.params = params;
        this.tooltip = this.params.tooltipGetter?.(this.params);
    }

    refresh() {
        return false;
    }

    onEllipsedChange(next: boolean) {
        const now = Date.now();
        if (now < this.lockUntil) return;

        if (next) {
            this.isNameEllipsed = true;
            this.lockUntil = now + 200;
        } else {
            this.isNameEllipsed = false;
        }
    }
}
